export default __webpack_public_path__ + "navigation-examples-advanced-v1-960-2a4c2fc193bb93a1343249c3377ad690.png";